import { SvgIcon, SvgIconProps } from "@mui/material";

export const CodeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <rect width="24" height="24" fill="#fff" rx="4" />
      <rect
        width="18"
        height="18"
        x="3"
        y="3"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        rx="5"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M10 14.5 7.5 12 10 9.5M14 9.5l2.5 2.5-2.5 2.5"
      />
    </svg>
  </SvgIcon>
);
